<template lang="pug">
  b-card(:no-block='true', :class='colorClass', no-body)
    b-card-body.pb-0
      b-dropdown.float-right(variant='transparent p-0', right, v-if='actions')
        template(slot='button-content')
          i.icon-settings
        b-dropdown-item(v-for='action in actions', :key='action.name') {{ action.name }}
      h4.mb-0
        slot N/A
      p {{ category }}
      div(style='height: 70px', height='70')
    //- line-chart.chart-wrapper.px-3(style='height: 70px', height='70', :dataInput='data', :labelInput='label')
    small.py-1.px-3
      i.fa.fa-check
      |  Synced
</template>

<script>
export default {
  name: 'statsbox',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    category: {
      type: String,
      default: 'Uncategorised',
    },
    actions: Array,
    data: Array,
    label: Array,
  },
  computed: {
    colorClass() {
      return `bg-${this.color}`
    },
  },
  methods: {
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Statsbox.vue?b23df234